<template>
  <TipMatchPopupContainer
    v-if="show"
    :popup-title="`登录提示`"
    :is-showpopup-close="isShowpopupClose"
    z-index="100"
    @onCancel="dimissDialog"
  >
    <div class="tip-match-auth-wrap">
      <img
        :src="getCompressImgUrl(logo, 80 , 80)"
        class="tip-match-auth-logo"
        alt="logo"
      >
      <p>{{ tipDesc }}</p>
      <div
        class="tip-match-auth-btn"
        @click.stop="clickAuth()"
      >
        {{ btnText }}
      </div>
    </div>
  </TipMatchPopupContainer>
</template>
<script>
import TipMatchPopupContainer from '@tencent/press-ui/press-popup/press-popup';
export default {
  components: {
    TipMatchPopupContainer,
  },
  props: {
    dialogIsShow: {
      type: Boolean,
      desc: '显示弹窗',
      default: false,
    },
  },
  options: {
    virtualHost: true,
  },
  data() {
    return {
      show: false,
      isShowpopupClose: true,
      logo: 'https://image-1251917893.file.myqcloud.com/Esports/new/user/login-logo.png',
      tipDesc: '授权登录王者赛宝获得更多服务',
      btnText: '授权登录',
      resolve: '',
      reject: '',
      promise: '',
    };
  },
  watch: {
    dialogIsShow: {
      handler(value) {
        this.show = value;
      },
      immediate: true,
    },
  },
  methods: {
    dimissDialog() {
      this.$ebus.emit('dimissAuthDialog');
      this.$emit('dimissDialog');
      if (this.reject) {
        this.reject();
      }
      this.show = false;
    },
    clickAuth() {
      this.$ebus.emit('clickAuth');
      this.$emit('clickAuth');
      if (this.resolve) {
        this.resolve();
      }
      this.show = false;
    },
    showDialog(options) {
      this.show = true;

      if (options) {
        Object.keys(options).map((key) => {
          this[key] = options[key];
        });
      }
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
      // 返回promise对象
      return this.promise;
    },
  },
};

</script>
<style lang="scss"  src="./css/index.scss"></style>
